import CashbacksData from './CashbacksData';

export default CashbacksData;
